import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/circle/style/index.js
// module id = k8WF
// module chunks = 0